import {useEffect, useState} from "react";
import localforage from "localforage";

localforage.config({
    name: "lott-live-reactjs",
    storeName: "images",
});

export const useLocalImage = (key) => {
    const [image, setImageUrl] = useState(null);

    // Load on mount
    useEffect(() => {
        let revokedUrl = null;

        (async () => {
            const blob = await localforage.getItem(key);
            if (blob) {
                const url = URL.createObjectURL(blob);
                revokedUrl = url;
                setImageUrl(url);
            }
        })();

        return () => {
            if (revokedUrl) URL.revokeObjectURL(revokedUrl);
        };
    }, [key]);

    const saveImage = async (file) => {
        if (!file) return;

        await localforage.setItem(key, file); // store as Blob
        const url = URL.createObjectURL(file);
        setImageUrl(url);
    };

    const clearImage = async () => {
        await localforage.removeItem(key);
        if (image) URL.revokeObjectURL(image);
        setImageUrl(null);
    };

    return {image, saveImage, clearImage};
};
